import React, { useState, useEffect } from "react";
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

const CounterStyleThree = () => {
    const [state, setState] = useState(true);
    const [counters, setCounters] = useState([]); // State to hold counters data

    // Fetch data from the API when the component mounts
    useEffect(() => {
        fetch('https://yautiktechnology.com/api/project-counter')
            .then(response => response.json())
            .then(data => {
                // Process the data to match the expected format
                const formattedData = data.map(counter => ({
                    countNum: parseInt(counter.count), // Convert the count to an integer
                    countTitle: counter.heading,
                    counterPrefix: counter.count.includes('+') ? '+' : '',
                }));
                setCounters(formattedData); // Update state with the formatted data
            })
            .catch(error => {
                console.error("Error fetching data: ", error);
            });
    }, []);

    return (
        <div className="rs-counter style3 modify1 pt-90 pb-80 md-pb-30">
            <div className="container">
                <div className="counter-top-area">
                    {counters.length > 0 ? (
                        <div className="row">
                            {counters.map((counter, num) => (
                                <div key={num} className="col-xl-3 col-lg-3 col-md-6 md-mb-50">
                                    <div className="counter-list">
                                        <div className="counter-text">
                                            <div className="count-number">
                                                <span className="rs-count">
                                                    <CountUp
                                                        start={state ? 0 : counter.countNum}
                                                        end={counter.countNum}
                                                        duration={10}
                                                        onEnd={() => setState(false)}
                                                    />
                                                    {({ countUpRef, start }) => (
                                                        <VisibilitySensor onChange={start} delayedCall>
                                                            <span ref={countUpRef} />
                                                        </VisibilitySensor>
                                                    )}
                                                </span>
                                                <span className="prefix">{counter.counterPrefix}</span>
                                            </div>
                                            <h3 className="title">{counter.countTitle}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div>Loading...</div> // Show a loading message while data is being fetched
                    )}
                </div>
            </div>
        </div>
    );
};

export default CounterStyleThree;
